export default __webpack_public_path__ + "static/media/Flag_of_Estonia.c2116427.svg";